import type { SupplyRepository } from '@zetyar/data-contracts'
import { createSupabaseSupplyRepository } from '@zetyar/supabase-client'
import { getSupabaseClient } from '@/infrastructure/supabase/app'

export const webSupplyRepository: SupplyRepository = createSupabaseSupplyRepository(getSupabaseClient())
